export const authenticationConstants = {
  REGISTER_REQUEST: "REGISTER_DEVICE_REQUEST",
  REGISTER_SUCCESS: "REGISTER_DEVICE_SUCCESS",
  REGISTER_FAILURE: "REGISTER_DEVICE_FAILURE",

  AUTHENTICATE_REQUEST: "AUTHENTICATE_DEVICE_REQUEST",
  AUTHENTICATE_SUCCESS: "AUTHENTICATE_DEVICE_SUCCESS",
  AUTHENTICATE_FAILURE: "AUTHENTICATE_DEVICE_FAILURE",

  ORGANIZATION_REQUEST: "ORGANIZATION_REQUEST",
  ORGANIZATION_SUCCESS: "ORGANIZATION_SUCCESS",
  ORGANIZATION_FAILURE: "ORGANIZATION_FAILURE",

  ORGANIZATION_LOGO_REQUEST: "ORGANIZATION_LOGO_REQUEST",
  ORGANIZATION_LOGO_SUCCESS: "ORGANIZATION_LOGO_SUCCESS",
  ORGANIZATION_LOGO_FAILURE: "ORGANIZATION_LOGO_FAILURE",
};
